import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../../layout/Layout";
import LayoutSetting, {
  ILayoutSetting,
} from "../../../layout/setting/LayoutSetting";

export default function BulananLayoutSetting() {
  const menu: ILayoutSetting = {
    title: "Setting Bulanan",
    menus: [
      { id: 1, text: "Desain", to: "/setting-bulanan" },
      { id: 2, text: "Peserta", to: "/setting-bulanan/peserta" },
      { id: 3, text: "Histori", to: "/setting-bulanan/histori" },
      { id: 4, text: "Custom Pemenang", to: "/setting-bulanan/pemenang" },
      { id: 5, text: "View", to: "/bulanan" },
    ],
  };

  return (
    <Fragment>
      <Layout hideOutlet={true}></Layout>
      <div style={{ display: "flex" }}>
        <LayoutSetting menus={menu.menus} title={menu.title}></LayoutSetting>
        <div style={{ padding: 20, width: "100%" }}>
          <Outlet></Outlet>
        </div>
      </div>
    </Fragment>
  );
}
